import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  DropZone,
  Stack,
  Thumbnail,
  InlineError,
  Text,
} from "@shopify/polaris";
import { readString } from "react-papaparse";
import { NoteMinor } from "@shopify/polaris-icons";
export default function CsvUpload(props) {
  const { t } = useTranslation();
  //The CSV file
  const [csv, setCsv] = useState();
  const [csvError, setCsvError] = useState(null);
  //The CSV data

  useEffect(() => {
    if (csv) {
      setCsvError();
      if (csv[0].size < 50000000) {
        var reader = new FileReader();
        reader.readAsText(csv[0]);
        reader.onload = (event) => {
          props.onCsvLoad(event.target.result);
          // console.log(event.target.result);
          // console.log(readString(event.target.result, { header: true }));
        };
      } else {
        setCsvError(t("import.errors.csvTooLarge"));
      }
    }
  }, [csv]);

  function thumbnailFor(csv) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Stack alignment="center">
          <Thumbnail size="small" alt={csv.name} source={NoteMinor} />
          <div>
            <strong>{csv.name}</strong>
            <Text variant="bodySm" as="p">
              {csv.size} bytes
            </Text>
          </div>
        </Stack>
      </div>
    );
  }
  const dropZoneMarkup = csv ? thumbnailFor(csv[0]) : <DropZone.FileUpload />;

  return (
    <>
      <DropZone
        allowMultiple={false}
        accept=".csv, text/csv"
        onDrop={setCsv}
        id="csv-upload"
      >
        {dropZoneMarkup}
      </DropZone>
      {csvError && (
        <div style={{ marginTop: "2rem" }}>
          <InlineError message={csvError} fieldID="csv-upload" />
        </div>
      )}
    </>
  );
}
